import downstreamElements from "./downstream-elements";
import downstreamEvents from "./downstream-events";
import downstreamMainGrid from "./downstream-main-grid";

export default function (nameAction, namePage) {
    if (nameAction === 'requestform')
        downstreamElements()
            .then(_ => downstreamEvents())

    if (nameAction === 'requestgrid')
        downstreamMainGrid();

}

